
import {
  querySearch,
  queryLatestPosts,
} from '@/graphql/wordpress/query/search.js'

export default {
  name: 'Results',
  props: {
    params: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    latest: undefined,
    searched: undefined,
    loading: false,
  }),
  async fetch() {
    try {
      this.loading = true
      this.latest = await this.$apollo
        .query({
          query: queryLatestPosts,
          variables: {
            first: 5,
          },
        })
        .then(({ data }) => data)
      this.loading = false
    } catch (e) {
      console.error(e)
      this.loading = false
      return this.$nuxt.context.error({ statusCode: 500 })
    }
  },
  computed: {
    results() {
      return this.searched?.posts?.edges?.length ? this.searched : []
    },
  },
  watch: {
    async params(params) {
      if (params.length) {
        this.searched = await this.getResult(params)
      } else {
        this.searched = []
      }
    },
  },
  methods: {
    async getResult(params) {
      try {
        this.loading = true
        this.$nuxt.$loading.start()

        const posts = await this.$apollo
          .query({
            query: querySearch,
            variables: {
              where: {
                search: params,
              },
              first: 5,
            },
          })
          .then(({ data }) => data)
        this.$nuxt.$loading.finish()
        this.loading = false
        return posts
      } catch (e) {
        console.error(e)
        this.loading = false
        return this.$nuxt.context.error({ statusCode: 500 })
      }
    },
    mergePosts(data) {
      const searched = this.searched.posts
      this.searched.posts = {
        edges: searched.edges.concat(data.posts.edges),
        pageInfo: data.posts.pageInfo,
      }
    },
  },
}
